<template>
  <div class="main-box" :class="{ isMobile: isMobile }">
    <header-top v-if="!isMobile"></header-top>
    <mobile-header v-if="isMobile" />
    <div class="main-container">
      <router-view />
    </div>
    <footer-bottom></footer-bottom>
    <right-bar></right-bar>
  </div>
</template>

<script>
import headerTop from '@/components/header'
import mobileHeader from '@/components/header/mobile-header.vue'
import footerBottom from '@/components/footer'
import rightBar from '@/components/rightbar'

export default {
  components: {
    headerTop,
    mobileHeader,
    footerBottom,
    rightBar,
  },
  data() {
    return {
      isMobile: false,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
    this.$bus.on('chatShow', this.chatShow)
    this.$bus.on('chatHide', this.chatHide)
    this.$bus.on('goTest', this.goTest)
    this.$bus.on('compRegistor', this.compRegistor)
  },
  mounted() {
    this.$bus.emit('loadSiteConfig')
    console.error = console.log
  },
  beforeDestroy() {
    this.$bus.$off('chatShow')
    this.$bus.$off('chatHide')
    this.$bus.$off('goTest')
    this.$bus.$off('compRegistor')
  },
  methods: {
    chatShow() {
      _MEIQIA('withoutBtn')
      _MEIQIA('init')
      _MEIQIA('showPanel')
      _MEIQIA('endConversation', this.chatHide)
    },
    chatHide() {
      _MEIQIA('hidePanel')
    },
    goTest() {
      if(window.opener && window.opener.window){
        window.opener.focus()
        return;
      }
      window.opener = window.open(
        'https://enjoy.acmcoder.com/cand/public?q=NWZlMDYzYjA0MGY0ODIwMGE5Mzg1MTNiJiY1ZmUwNGIwYjQwZjQ4MjAwYTkzODUwOTImJnRlc3Q=&r=auto'
      )
    },
    compRegistor() {
      //如果登录，跳转到控制台
      this.info = this.$cookies.get('hr_token')
      if (this.info) {
        if (this.info.finish) {
          location.href = 'https://kao.acmcoder.com/b/'
        } else {
          this.$message.warning('请先完善企业信息！')
          this.$router.push('/register/compInfo')
        }
      }
      //如果没有登录，直接跳转到注册页
      else {
        this.$router.push('/register')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-box {
  min-width: 1200px;
  &.isMobile {
    min-width: initial;
  }
  .main-container {
    padding-top: 60px;
    min-height: 650px;
  }
}
</style>
<style>
body,
html {
  margin: 0;
  height: 100%;
}
body {
  font-family: Microsoft Yahei;
  color: #333333;
  background-color: #f8f9fb;
  box-sizing: border-box;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue